import React, { FC } from 'react';
import { AdminSignupView } from '../../components';

export const AdminSignupPage: FC = () => <AdminSignupView />;
